<!-- Scrim fills the remaining width; tapping it closes, as ChatGPT's does. -->
<div class="scrim" (click)="closed.emit()" aria-hidden="true"></div>

<section
  class="hist"
  role="dialog"
  aria-label="Chat history"
  (keydown.escape)="closed.emit()"
  (click)="closeMenu()"
>
  <!-- Search -->
  <div class="hist__search">
    <span class="hist__search-glyph" aria-hidden="true">⌕</span>
    <input
      #searchField
      type="text"
      class="hist__search-input"
      placeholder="Search chats"
      aria-label="Search chats"
      [value]="query"
      (input)="onQuery($any($event.target).value)"
      autocomplete="off"
    />
    <button *ngIf="query" type="button" class="hist__search-clear" aria-label="Clear search" (click)="clearQuery()">✕</button>
  </div>

  <div class="hist__list">

    <ng-container *ngFor="let group of groups; trackBy: trackGroup">
      <div class="hist__group">{{ group.label }}</div>

      <ng-container *ngFor="let thread of group.threads; trackBy: trackThread">
        <ng-container
          *ngTemplateOutlet="row; context: { $implicit: thread, archived: false }"
        ></ng-container>
      </ng-container>
    </ng-container>

    <p class="hist__empty" *ngIf="!groups.length">
      {{ query ? 'No chats match “' + query + '”.' : 'No chats yet.' }}
    </p>

    <!-- Archived, collapsed by default -->
    <ng-container *ngIf="archivedCount">
      <button type="button" class="hist__archived-toggle" [attr.aria-expanded]="showArchived" (click)="toggleArchivedSection()">
        <span class="hist__archived-caret" [class.hist__archived-caret--open]="showArchived" aria-hidden="true">▸</span>
        Archived ({{ archivedCount }})
      </button>

      <ng-container *ngIf="showArchived">
        <ng-container *ngFor="let group of archivedGroups; trackBy: trackGroup">
          <div class="hist__group">{{ group.label }}</div>
          <ng-container *ngFor="let thread of group.threads; trackBy: trackThread">
            <ng-container
              *ngTemplateOutlet="row; context: { $implicit: thread, archived: true }"
            ></ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>

  <button type="button" class="hist__new" (click)="newChat()">
    <span aria-hidden="true">＋</span> New chat
  </button>
</section>

<!-- ------------------------------------------------------------------ -->
<!-- One row template, reused for the live list and the archived list.   -->
<!-- ------------------------------------------------------------------ -->
<ng-template #row let-thread let-archived="archived">
  <div
    class="hist__row"
    [class.hist__row--active]="thread.id === activeId"
    [class.hist__row--menu]="menuThreadId === thread.id"
  >
    <!-- Inline rename, so no dialog is needed. -->
    <input
      *ngIf="renamingThreadId === thread.id; else rowBody"
      #renameField
      type="text"
      class="hist__rename"
      aria-label="Rename chat"
      [value]="renameValue"
      (input)="renameValue = $any($event.target).value"
      (keydown.enter)="commitRename()"
      (keydown.escape)="cancelRename()"
      (blur)="commitRename()"
      (click)="$event.stopPropagation()"
    />

    <ng-template #rowBody>
      <button type="button" class="hist__open" (click)="select(thread)">
        <span class="hist__pin" *ngIf="thread.pinned" aria-label="Pinned">▲</span>
        <span class="hist__title">{{ thread.title }}</span>
        <span class="hist__snippet" *ngIf="snippet(thread) as s">{{ s }}</span>
      </button>

      <span class="hist__age" *ngIf="copiedThreadId !== thread.id">{{ age(thread) }}</span>
      <span class="hist__copied" *ngIf="copiedThreadId === thread.id" role="status">copied</span>

      <button
        type="button"
        class="hist__more"
        [attr.aria-label]="'Options for ' + thread.title"
        [attr.aria-expanded]="menuThreadId === thread.id"
        (click)="toggleMenu(thread, $event)"
      >
        ⋯
      </button>
    </ng-template>

    <!-- Row menu -->
    <div class="hist__menu" *ngIf="menuThreadId === thread.id" (click)="$event.stopPropagation()">
      <button type="button" class="hist__menu-item" (click)="startRename(thread, $event)">Rename</button>
      <button type="button" class="hist__menu-item" *ngIf="!archived" (click)="togglePin(thread, $event)">
        {{ thread.pinned ? 'Unpin' : 'Pin to top' }}
      </button>
      <button type="button" class="hist__menu-item" (click)="exportThread(thread, $event)">Export</button>
      <button type="button" class="hist__menu-item" *ngIf="!archived" (click)="archive(thread, $event)">Archive</button>
      <button type="button" class="hist__menu-item" *ngIf="archived" (click)="unarchive(thread, $event)">Unarchive</button>
      <button type="button" class="hist__menu-item hist__menu-item--danger" (click)="askDelete(thread, $event)">Delete</button>
    </div>

    <!-- Delete confirms in place — no modal (2d). -->
    <div class="hist__confirm" *ngIf="confirmingDeleteId === thread.id" (click)="$event.stopPropagation()">
      <span class="hist__confirm-text">Delete this chat?</span>
      <button type="button" class="hist__confirm-no" (click)="cancelDelete($event)">Cancel</button>
      <button type="button" class="hist__confirm-yes" (click)="confirmDelete(thread, $event)">Delete</button>
    </div>
  </div>
</ng-template>
